/* __next_internal_client_entry_do_not_use__ QueryClientProvider auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { shouldRetryEndpoint } from "@faire/web--source/common/shouldRetryEndpoint";
import { QueryClientProvider as ReactQueryClientProvider, QueryClient, defaultShouldDehydrateQuery } from "@tanstack/react-query";
import React, { useState } from "react";
export var QueryClientProvider = function(param) {
    var children = param.children;
    var _useState = _sliced_to_array(useState(function() {
        return new QueryClient({
            defaultOptions: {
                queries: {
                    refetchOnWindowFocus: false,
                    retry: shouldRetryEndpoint
                },
                dehydrate: {
                    shouldDehydrateQuery: function(query) {
                        return defaultShouldDehydrateQuery(query) || query.state.status === "pending";
                    }
                }
            }
        });
    }), 1), queryClient = _useState[0];
    return /*#__PURE__*/ _jsx(ReactQueryClientProvider, {
        client: queryClient,
        children: children
    });
};
